// extracted by mini-css-extract-plugin
export default {"dlSelectedFilters":"src-js-containers-filtering-components-SelectedFilters---dlSelectedFilters---hoTOM"};